import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function listAgentHolidays(): Promise<{ data: any[] }> {
  return axios.get(`${API_URL}/api/crm/agents-schedule/`);
}
